import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client'; // Use `react-dom/client` for `createRoot`
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeProvider from './theme';
import { AuthProvider } from './auth';
import DataProvider from './api';
import { BrowserRouter as Router } from 'react-router-dom';
import { Spinner } from '@chakra-ui/react';

// Get the root element from the DOM
const rootElement = document.getElementById('root');

// Create a root using `createRoot`
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <Suspense fallback={<Spinner />}>
        <Router>
          <DataProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </DataProvider>
        </Router>
      </Suspense>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
